import { apiError } from '../apiError';
import axiosInstance from '../axios.config';
import { ApiResponse } from 'types';

/**
 * IVR/agent flow states — aligned to the LIVE runtime schema (teeoff-ivr-gateway
 * .state_details). Lowercase enums, action_details/type_meta are raw TEXT (JSON
 * stored as text). Backend: teeoff-cpass-backend /telephony/ivr/state-details.
 */
export type CallRequest = 'inbound' | 'outbound';
export type ActionType = 'static' | 'api_call' | 'function_call';
export type ContextType = 'bypass' | 'dtmf' | 'endcall' | 'stream' | 'transfer' | 'voice_mail';

export interface StateDetail {
  id?: number;
  operator_id: string;
  service_id: string;
  name: string;
  language?: string;
  type?: string;
  action?: ActionType | string;
  action_details?: string;   // TEXT (raw, often JSON)
  context_type?: ContextType | string;
  type_meta?: string;        // TEXT JSON: { "choices": [ { key, value, msg, nextState } ] }
  is_blocked?: number;
  business_name?: string;
  attributes?: string;
  call_request?: CallRequest | string | null;
  created_at?: string;
}

const BASE = '/ivr/state-details';
// Shared so a 403 reads as a refusal rather than a load failure.
const err = (e: any, msg: string) => apiError(e, msg);

export const stateDetailsService = {
  list: async (params?: { operatorId?: string; serviceId?: string }): Promise<ApiResponse<StateDetail[]>> => {
    try { return (await axiosInstance.get(BASE, { params })).data; } catch (e: any) { return err(e, 'Failed to load states'); }
  },
  create: async (data: StateDetail): Promise<ApiResponse<StateDetail>> => {
    try { return (await axiosInstance.post(BASE, data)).data; } catch (e: any) { return err(e, 'Failed to create'); }
  },
  update: async (id: number, data: Partial<StateDetail>): Promise<ApiResponse<StateDetail>> => {
    try { return (await axiosInstance.put(`${BASE}/${id}`, data)).data; } catch (e: any) { return err(e, 'Failed to update'); }
  },
  remove: async (id: number): Promise<ApiResponse<void>> => {
    try { return (await axiosInstance.delete(`${BASE}/${id}`)).data; } catch (e: any) { return err(e, 'Failed to delete'); }
  }
};
